import { PropsWithChildren } from 'react'

import { StatsigBrowserProvider } from './statsig-provider.browser'
import { StatsigServerProvider } from './statsig-provider.server'
import { StatsigUserAgnosticProvider } from './statsig-user-agnostic'
import { getStatsigUser } from './statsig.helpers'

import type { StatsigServerProps } from './statsig.types'

type IsomorphicStatsigProvider = PropsWithChildren<{
  statsigServerProps: StatsigServerProps | null | undefined
}>

export function IsomorphicStatsigProvider({ children, statsigServerProps }: IsomorphicStatsigProvider) {
  if (statsigServerProps) {
    return <StatsigServerProvider statsigServerProps={statsigServerProps}>{children}</StatsigServerProvider>
  }

  const statsigUser = getStatsigUser()
  if (statsigUser) {
    return <StatsigBrowserProvider statsigUser={statsigUser}>{children}</StatsigBrowserProvider> //
  }

  return <StatsigUserAgnosticProvider>{children}</StatsigUserAgnosticProvider> //default Provider for Server
}
